export const sectionNameMap = {
  employmentlaw: "Employment Law Knowledge Hub",
  healthandsafety: "Health & Safety Knowledge Hub",
};
